import { Component, Input, OnInit } from "@angular/core";
import { LmsService } from "../services/lms.service";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";

@Component({
    selector: "app-lms-view-closer",
    templateUrl: "./lms-view-closer.component.html",
    styleUrls: ["./lms-view-closer.component.scss"],
    standalone: false
})
export class LmsViewCloserComponent implements OnInit {
  PreCloserMethodList: any = [];
  showSpinner: boolean = false;
  Waiver_Account_Id: any = 0;
  PreCloserDetails: any = {
    LoanCloser_EffectiveDate: new Date(),
    CloserType: "",
  };
  InterMediatAccountId: any = 0
  totalCalculator: any = {
    totalDueAmount: 0,
    totalReceiveAmount: 0,
    totalWaiverAmount: 0,
    totalBalance: 0,
  };
  isCheckedCustomer: boolean = true;
  accountName_Not_Bind: any = "";
  PrintCloserMethodList: any = [];
  @Input() loanSummary: any;
  currentUser: any;
  _prevDate: any;
  LoanChargesRecoverableList: any;
  LoanChargesRecoverable_Balance: any = 0;
  LoanChargesRecoverable: any = { Due_Amount: 0, Received_Amount: 0 };
  MinEffectiveDate = new Date();
  isExpired: boolean = false;
  isMyCloserRequest: boolean = false;
  isWavierGivenByMe: boolean = false;
  Loan_Acc_Type: any = "";
  constructor(
    private lmsService: LmsService,
    private dataSharingService: DataSharingService
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("View Closure");
    console.log("loan Summary Details", this.loanSummary);
    this.LMS_Get_Loan_Closer_Due_Detail(
      new Date(
        this.PreCloserDetails.LoanCloser_EffectiveDate
      ).toLocaleDateString("fr-CA")
    );
  }

  onEffectiveDateChange() {
    this.LMS_Get_Loan_Closer_Due_Detail(
      new Date(
        this.PreCloserDetails.LoanCloser_EffectiveDate
      ).toLocaleDateString("fr-CA")
    );
  }

  LMS_Get_Loan_Closer_Due_Detail(date: any) {
    this.showSpinner = true;
    this.lmsService
      .LMS_Get_Loan_Closer_Due_Detail_New({
        Loan_Id: this.loanSummary.LoanId,
        LoginUserId: this.currentUser.userId,
        EffictiveDate: date,
        LoanCloserId: 0,
        IsIntermediate: this.isCheckedCustomer  ? 1 : 0
      })
      .subscribe((res: any) => {
        if (res != null) {
          console.log("resultttt", res);
          let _data = res.Item1[0] || {};
          this.InterMediatAccountId = _data.InterMediatAccountId;
          this.Waiver_Account_Id =
            _data.Waiver_Account_Id == null ? 0 : _data.Waiver_Account_Id;
          _data.LoanCloser_EffectiveDate = new Date(
            _data.LoanCloser_EffectiveDate
          );
          _data.NextDueDate = new Date(_data.NextDueDate);
          this._prevDate = _data.LoanCloser_EffectiveDate;
          _data.CloserType =
            _data.CloserType == "" || _data.CloserType == null
              ? this.PreCloserDetails.CloserType
              : _data.CloserType;
          this.Loan_Acc_Type = _data.Loan_Acc_Type;
          this.PreCloserDetails = _data;
          this.PreCloserMethodList = res.Item2 ? res.Item2 : [];
          this.PrintCloserMethodList = res.Item2 ? res.Item2 : [];
          var headName = "";
          this.PreCloserMethodList.map((item) => {
            item.newBalance =
              item.Balance < 0 ? item.Balance * -1 : item.Balance;
            if (
              (item.AccountHeadId == null ||
                item.AccountHeadId == "" ||
                item.AccountHeadId == 0) &&
              item.ChagesHead != null
            ) {
              headName = item.ChagesHead;
              if (item.HeadId == 5) {
                headName = "Broken Period Interest";
              }
              this.accountName_Not_Bind =
                this.accountName_Not_Bind + headName + ",";
            }
          });
          this.PreCloserDetails.Waiver_GivenBy =
            this.PreCloserDetails.Waiver_GivenBy;
          if (
            this.PreCloserDetails.Closer_RequestStatus != "Closed" &&
            new Date().toLocaleDateString("fr-CA") !=
            new Date(
              this.PreCloserDetails.LoanCloser_EffectiveDate
            ).toLocaleDateString("fr-CA")
          ) {
            this.isExpired =
              this.PreCloserDetails.LoanCloser_EffectiveDate.getTime() <
              this.MinEffectiveDate.getTime();
          }
          this.isMyCloserRequest =
            (this.PreCloserDetails.LoanCloser_RequestBy || "").toString() ==
            this.currentUser.userId.toString();
          this.isWavierGivenByMe =
            (this.PreCloserDetails.Waiver_GivenBy || "").toString() ==
            this.currentUser.userId.toString();
          this.onCalculateAmount();
          // this.lmsService
          //   .ACC_Get_ChargesHead_Amount_Details({
          //     LoanId: JSON.parse(this.loanSummary.LoanId),
          //     ChargeHeadId: 35,
          //   })
          //   .subscribe((result: any) => {
          //     if (result.Item1.length > 0) {
          //       this.LoanChargesRecoverableList = result.Item1;
          //       this.LoanChargesRecoverable = result.Item2[0];
          //       this.LoanChargesRecoverable_Balance =
          //         result.Item2[0].Due_Amount - result.Item2[0].Received_Amount;
          //     }
          //   });
          this.LoanChargesRecoverableList = res.Item3;
          this.LoanChargesRecoverable = res.Item4[0];
          this.LoanChargesRecoverable_Balance =
            res.Item4[0].Due_Amount - res.Item4[0].Received_Amount;

          this.showSpinner = false;
        }
      });
  }

  onCalculateAmount() {
    let _totalDue: any = 0;
    let _totalReceived: any = 0;
    let _totalWaiver: any = 0;
    let _totalBalance: any = 0;
    let _maxWaiver: any = 0;
    let _wc: any = 0;
    this.PreCloserMethodList.forEach((obj) => {
      _totalDue = _totalDue + obj.DueAmount;
      _totalReceived = _totalReceived + obj.ReceiveAmount;
      _totalWaiver = _totalWaiver + Number(obj.WaiverAmount);
      _totalBalance = _totalBalance + obj.Balance;
      obj.initialWaiverAmount = obj.WaiverAmount || 0;
      obj.lastWaiverAmount = obj.WaiverAmount || 0;
      obj.initialBalance = obj.initialBalance || obj.Balance + obj.WaiverAmount;
      if (obj.HeadId != 27 || obj.HeadId != 34) {
        _maxWaiver = _maxWaiver + obj.Balance;
      }
      const _cal = obj.DueAmount - obj.ReceiveAmount;
      if (obj.HeadId == 30 || obj.HeadId == 5) {
        _wc = _wc + (_cal < 0 ? 0 : _cal);
      } else {
        _wc = _wc + _cal;
      }
    });

    this.totalCalculator = {
      totalDueAmount: Number(_totalDue),
      totalReceiveAmount: Number(_totalReceived),
      totalWaiverAmount: Number(_totalWaiver),
      totalBalance: Number(_totalBalance),
      maxWaiver: Number(_maxWaiver),
    };
    this.PreCloserDetails.Waiver_Limit_Per_Amt =
      (_wc * this.PreCloserDetails.Waiver_Limit_Per) / 100;
    this.PreCloserDetails.Waiver_Limit_Per_Amt_R =
      this.PreCloserDetails.Waiver_Limit_Per_Amt <
        this.PreCloserDetails.Waiver_Limit_Amt
        ? this.PreCloserDetails.Waiver_Limit_Per_Amt
        : this.PreCloserDetails.Waiver_Limit_Amt;

    if (!this.PreCloserDetails.isFirstTimeCalculate) {
      let _tr =
        this.totalCalculator.totalBalance < 0
          ? 0
          : this.totalCalculator.totalBalance;

      if (
        !this.PreCloserDetails.CloserId &&
        (!this.PreCloserDetails.CustomerAgreed_Amount ||
          this.PreCloserDetails.CustomerAgreed_Amount <= 0)
      )
        this.PreCloserDetails.CustomerAgreed_Amount = _tr;
      this.PreCloserDetails.Prev_CustomerAgreed_Amount =
        this.PreCloserDetails.CustomerAgreed_Amount;
      this.PreCloserDetails.totalWaiverAmount =
        _tr - this.PreCloserDetails.CustomerAgreed_Amount;
      this.PreCloserDetails.isFirstTimeCalculate = true;
      // if (this.PreCloserDetails.CloserId) {
      //   this.LMS_Get_User_For_Waiver_Approval();
      //   if (this.PreCloserDetails.Closer_RequestStatus == "Waiver Approved") {
      //     this.PreCloserDetails.totalWaiverAmount =
      //       this.PreCloserDetails.TotalWaiver_Approved;
      //   }
      //   if (this.PreCloserDetails.Closer_RequestStatus == "Waiver Pending") {
      //     this.isShowForward = true;
      //   } else if (
      //     this.PreCloserDetails.totalWaiverAmount >
      //     this.PreCloserDetails.Waiver_Limit_Per_Amt_R
      //   ) {
      //     this.isShowForward =
      //       this.PreCloserDetails.Closer_RequestStatus !== "Waiver Approved";
      //   }
      // }
    }
  }
}
